/** Additional shopping events. Reuses the existing Google tag; never records purchases. */
(() => {
  if (window.fpAnalytics || window.Shopify?.designMode) return;
  const events = new Set([
    'contact_click', 'generate_lead', 'personalisation_start',
    'personalisation_confirm', 'personalisation_remove',
    'catalogue_navigation', 'vehicle_finder_select', 'collection_filter_apply',
    'product_finder_complete', 'results_empty', 'offer_open', 'offer_dismiss',
    'newsletter_signup',
  ]);
  const fields = new Set([
    'contact_method', 'lead_type', 'product_id', 'product_handle', 'branded_seats',
    'catalogue', 'brand', 'model', 'fit', 'filter_count', 'navigation_level',
    'product_type', 'result_type',
  ]);
  function allowed() {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch { return false; }
  }
  function track(name, data = {}) {
    if (!events.has(name) || !allowed()) return false;
    const params = {};
    for (const [key, value] of Object.entries(data)) {
      if (!fields.has(key)) continue;
      if (typeof value === 'number' && Number.isFinite(value)) params[key] = value;
      else if (typeof value === 'string' && value.length <= 100 && !/[@?\n\r]/.test(value)) params[key] = value;
    }
    // Strip query strings and hashes: contact forms and search URLs can contain personal data.
    params.page_location = window.location.origin + window.location.pathname;
    params.send_to = 'G-LCCYKB3N52';
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      // Allows the existing consent-managed custom pixels to subscribe to these events.
      const { page_location, send_to, ...customData } = params;
      const published = window.Shopify?.analytics?.publish?.(`farmpacks:${name}`, customData);
      Promise.resolve(published).catch(() => {});
      return true;
    } catch { return false; } // Analytics must never interrupt shopping.
  }
  window.fpAnalytics = { track };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (link) {
      const href = link.getAttribute('href') || '';
      const method = href.startsWith('tel:') ? 'phone' : href.startsWith('mailto:') ? 'email' : '';
      if (method) track('contact_click', { contact_method: method });
      if (link.matches('.fp-catalog-nav__link')) {
        const tab = link.closest('[data-catalog]');
        track('catalogue_navigation', {
          catalogue: tab?.getAttribute('data-catalog') || '',
          navigation_level: href.includes('/products/') ? 'product' : 'brand',
        });
      }
    }
    const card = event.target.closest('.fp-brand-finder [data-catalog], .fp-brand-finder [data-brand], .fp-brand-finder [data-model], .fp-brand-finder [data-fit]');
    if (card && card !== card.closest('.fp-brand-finder')) {
      const root = card.closest('.fp-brand-finder');
      track('vehicle_finder_select', {
        catalogue: card.getAttribute('data-catalog') || root?.getAttribute('data-catalog') || '',
        navigation_level: card.hasAttribute('data-fit') ? 'fit' : card.hasAttribute('data-model') ? 'model' : card.hasAttribute('data-brand') ? 'brand' : 'catalogue',
      });
    }
  }, { capture: true });

  // A submit click is not a lead. Only Shopify's server-confirmed success counts,
  // once for a pending form submission, so refreshes do not inflate conversions.
  const pendingKey = (form) => `fp:lead:${window.location.pathname}:${form.id}`;
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('[name="contact[body]"]') || !allowed()) return;
    try { sessionStorage.setItem(pendingKey(form), 'pending'); } catch { /* storage unavailable */ }
  }, { capture: true });
  function confirmLeads() {
    document.querySelectorAll('[data-fp-lead-success]').forEach((success) => {
      const form = success.closest('form');
      if (!form || !allowed()) return;
      try {
        if (sessionStorage.getItem(pendingKey(form)) !== 'pending') return;
        sessionStorage.removeItem(pendingKey(form));
        track('generate_lead', { lead_type: success.getAttribute('data-fp-lead-success') });
      } catch { /* Do not guess a successful conversion when storage is unavailable. */ }
    });
  }
  confirmLeads();
  function confirmEmptyResults() {
    document.querySelectorAll('[data-fp-result-count="0"]').forEach((results) => {
      if (results.dataset.fpResultTracked === 'true') return;
      if (track('results_empty', { result_type: results.dataset.fpResultType })) {
        results.dataset.fpResultTracked = 'true';
      }
    });
  }
  confirmEmptyResults();
  // The shared consent API can finish loading after this deferred script.
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) { confirmLeads(); confirmEmptyResults(); }
    });
  }
})();
